import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "/",
      redirect: {
        name: "login"
      }
    },
    {
      path: "/master",
      component: resolve => {
        require(["@/views/master/index"], resolve);
      },
      children: [
        {
          path: "/",
          name: "home",
          component: resolve => {
            require(["@/views/master/home"], resolve);
          }
        },
        {
          path: "/data",
          name: "data",
          component: resolve => {
            require(["@/views/master/data"], resolve);
          }
        },
        {
          path: "/school",
          name: "school",
          component: resolve => {
            require(["@/views/master/school"], resolve);
          }
        },
        {
          path: "/city",
          name: "city",
          component: resolve => {
            require(["@/views/master/city"], resolve);
          }
        },
        {
          path: "/project",
          name: "project",
          component: resolve => {
            require(["@/views/master/project"], resolve);
          }
        },
        {
          path: "/projectCate",
          name: "projectCate",
          component: resolve => {
            require(["@/views/master/projectCate"], resolve);
          }
        },
        {
          path: "/order",
          name: "order",
          component: resolve => {
            require(["@/views/master/order"], resolve);
          }
        },
        {
          path: "/activityOrder",
          name: "activityOrder",
          component: resolve => {
            require(["@/views/master/activityOrder"], resolve);
          }
        },
        {
          path: "/collect",
          name: "collect",
          component: resolve => {
            require(["@/views/master/collect"], resolve);
          }
        },
        {
          path: "/activity",
          name: "activity",
          component: resolve => {
            require(["@/views/master/activity"], resolve);
          }
        },
        {
          path: "/activityEdit",
          name: "activityEdit",
          component: resolve => {
            require(["@/views/master/activityEdit"], resolve);
          }
        },
        {
          path: "/vipAdmin",
          name: "vipAdmin",
          component: resolve => {
            require(["@/views/master/vipAdmin"], resolve);
          }
        },
        {
          path: "/musicCate",
          name: "musicCate",
          component: resolve => {
            require(["@/views/master/musicCate"], resolve);
          }
        },
        {
          path: "/lessonsCate",
          name: "lessonsCate",
          component: resolve => {
            require(["@/views/master/lessonsCate"], resolve);
          }
        },
        {
          path: "/courseware",
          name: "courseware",
          component: resolve => {
            require(["@/views/master/courseware"], resolve);
          }
        },
        {
          path: "/courseMaterials",
          name: "courseMaterials",
          component: resolve => {
            require(["@/views/master/courseMaterials"], resolve);
          }
        },
        {
          path: "/cost",
          name: "cost",
          component: resolve => {
            require(["@/views/master/cost"], resolve);
          }
        },
        {
          path: "/banner",
          name: "banner",
          component: resolve => {
            require(["@/views/master/banner"], resolve);
          }
        },
        {
          path: "/star",
          name: "star",
          component: resolve => {
            require(["@/views/master/star"], resolve);
          }
        },
        {
          path: "/starCate",
          name: "starCate",
          component: resolve => {
            require(["@/views/master/starCate"], resolve);
          }
        },
        {
          path: "/newsCate",
          name: "newsCate",
          component: resolve => {
            require(["@/views/master/newsCate"], resolve);
          }
        },
        {
          path: "/help",
          name: "help",
          component: resolve => {
            require(["@/views/master/helpNews"], resolve);
          }
        },
        {
          path: "/ticket",
          name: "ticket",
          component: resolve => {
            require(["@/views/master/ticket"], resolve);
          }
        },
        {
          path: "/userTicket",
          name: "userTicket",
          component: resolve => {
            require(["@/views/master/userTicket"], resolve);
          }
        },
        {
          path: "/medal",
          name: "medal",
          component: resolve => {
            require(["@/views/master/medal"], resolve);
          }
        },
        {
          path: "/info",
          name: "info",
          component: resolve => {
            require(["@/views/master/info"], resolve);
          }
        },
        {
          path: "/ebookCate",
          name: "ebookCate",
          component: resolve => {
            require(["@/views/master/ebookCate"], resolve);
          }
        },
        {
          path: "/style",
          name: "style",
          component: resolve => {
            require(["@/views/master/style"], resolve);
          }
        },
        {
          path: "/album",
          name: "album",
          component: resolve => {
            require(["@/views/master/album"], resolve);
          }
        },
        {
          path: "/single",
          name: "single",
          component: resolve => {
            require(["@/views/master/single"], resolve);
          }
        },
        {
          path: "/videoReward",
          name: "videoReward",
          component: resolve => {
            require(["@/views/master/videoReward"], resolve);
          }
        },
        {
          path: "/term",
          name: "term",
          component: resolve => {
            require(["@/views/master/term"], resolve);
          }
        },
        {
          path: "/examList",
          name: "examList",
          component: resolve => {
            require(["@/views/master/examList"], resolve);
          }
        },
        {
          path: "/examQuestion",
          name: "examQuestion",
          component: resolve => {
            require(["@/views/master/examQuestion"], resolve);
          }
        },
        {
          path: "/examRecord",
          name: "examRecord",
          component: resolve => {
            require(["@/views/master/examRecord"], resolve);
          }
        },
        {
          path: "/version",
          name: "version",
          component: resolve => {
            require(["@/views/master/version"], resolve);
          }
        },
        {
          path: "/system/menu",
          name: "system/menu",
          component: resolve => {
            require(["@/views/master/system/menu"], resolve);
          }
        },
        {
          path: "/system/admin",
          name: "system/admin",
          component: resolve => {
            require(["@/views/master/system/admin"], resolve);
          }
        },
        {
          path: "/system/group",
          name: "system/group",
          component: resolve => {
            require(["@/views/master/system/group"], resolve);
          }
        },
        {
          path: "/system/projectPrice",
          name: "system/projectPrice",
          component: resolve => {
            require(["@/views/master/system/projectPrice"], resolve);
          }
        },
        {
          path: "/payment",
          name: "payment",
          component: resolve => {
            require(["@/views/master/payment"], resolve);
          }
        },
        {
          path: "/admin/agent",
          name: "admin/agent",
          component: resolve => {
            require(["@/views/master/admin/agent"], resolve);
          }
        },
        {
          path: "/system/dictManage",
          name: "system/dictManage",
          component: resolve => {
            require(["@/views/master/system/dictManage"], resolve);
          }
        }
      ]
    },
    {
      path: "/user",
      component: resolve => {
        require(["@/views/user/index"], resolve);
      },
      children: [
        {
          path: "login",
          name: "login",
          component: resolve => {
            require(["@/views/user/login"], resolve);
          }
        },
        {
          path: "register",
          name: "register",
          component: resolve => {
            require(["@/views/user/register"], resolve);
          }
        }
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  const masterId = Boolean(window.sessionStorage.getItem("masterId"));
  if (to.name == "login") {
    if (masterId) {
      next({
        name: "home"
      });
    } else {
      next();
    }
  } else {
    if (!masterId) {
      next({
        name: "login"
      });
    } else {
      next();
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js